<section class="py-16 px-3 sm:px-5 md:px-8 lg:px-16 xl:px-16 flex flex-col items-center">
  <div
    class="w-full justify-center gap-2 font-secondary text-4xl sm:text-8xl md:text-16xl lg:text-22xl font-extrabold py-16 px-10 text-center">
    <h1 i18n="@@autopark.about.title" class="text-secondary-600">
      Dlaczego
    <strong class="text-primary-500">
      ProcessWay?
    </strong>
    </h1>
  </div>
  <div
    class="grid gap-6
           grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
           auto-rows-[minmax(180px,auto)] w-full max-w-[1500px]">
    <div
      class="relative group rounded-xl sm:col-span-2 lg:row-span-1 h-[220px] lg:h-[500px] flex items-center justify-center overflow-hidden shadow-2xl">
      <img src="assets/parking/images/oleksii-topolianskyi-DJO2L1RQZZc-unsplash-min.jpg" alt="warsaw-pano"
           class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
      <div
        class="card-content">
          <span i18n="@@autopark.about.card-1-title" class="card-title">
            Strategiczna lokalizacja – Warszawa
          </span>
        <span i18n="@@autopark.about.card-1-content" class="card-desc">
          łatwy dostęp do tras i klientów
        </span>
      </div>
    </div>
    <div
      class="relative group rounded-xl
             lg:col-span-1 lg:row-span-1
             h-[500px] flex items-center justify-center overflow-hidden shadow-2xl">
      <img src="assets/parking/images/parking-video-cover.jpg" alt="availability" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
      <div
        class="card-content">
          <span i18n="@@autopark.about.card-2-title" class="card-title">
            Skala i dostępność
          </span>
        <span i18n="@@autopark.about.card-2-content" class="card-desc">
           1500 miejsc, jedno z największych rozwiązań na rynku
        </span>
      </div>
    </div>
    <div
      class="relative group rounded-xl
             h-[500px] lg:h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
      <img src="assets/parking/images/faq-img.69a6f8a6143c084d-min.png" alt="services" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
      <div
        class="card-content">
          <span i18n="@@autopark.about.card-3-title" class="card-title">
            Obsługa flot, nie handlarzy
          </span>
        <span i18n="@@autopark.about.card-3-content" class="card-desc">
          oferta dedykowana profesjonalnym klientom korporacyjnym
        </span>
      </div>
    </div>
    <div
      class="relative group rounded-xl
             h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
      <img src="assets/parking/images/mechanic-guy.60b698dc42131d75-min.png" alt="autopark-logistics" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
      <div
        class="card-content">
          <span i18n="@@autopark.about.card-4-title" class="card-title">
            Gotowa infrastruktura
          </span>
        <span i18n="@@autopark.about.card-4-content" class="card-desc">
          oszczędność czasu i kosztów inwestycji
        </span>
      </div>
    </div>
    <div
      class="relative group rounded-xl
             h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
      <img src="assets/parking/images/amina-atar-Mqc-m8kgxkg-unsplash-min.jpg" alt="transparency" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
      <div
        class="card-content">
          <span i18n="@@autopark.about.card-5-title" class="card-title">
            Elastyczność i transparentność
          </span>
        <span i18n="@@autopark.about.card-5-content" class="card-desc">
          możliwość krótkoterminowego lub długoterminowego wynajmu
        </span>
      </div>
    </div>
  </div>
</section>
